export default class Notices {
    constructor(isAjax = false) {
        this.noticesWrapper = document.getElementById("page__notices-wrapper");
        this.noticeContainer = document.querySelector(".jsPageNoticeWrapper");
        this.noticeList = document.querySelectorAll(".woocommerce-error");
        this.isAjax = isAjax;
        this.events();
    }

    events() {
        if (this.isAjax) {
            this.refreshNotices();
        } else {
            window.addEventListener(
                "DOMContentLoaded",
                this.showNotices.bind(this),
                { once: true }
            );
        }
    }

    refreshNotices() {
        if (this.noticeList) {
            this.noticeList.forEach((element) => {
                element.remove();
            });
        }

        const self = this;
        fetch(window.global.ajax_url + "?action=RefreshNotices", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (
                    data.success &&
                    data.data.notices != null &&
                    data.data.notices != ""
                ) {
                    self.noticesWrapper.innerHTML = data.data.notices;

                    if (self.noticeContainer) {
                        self.noticeContainer.classList.remove("is-hidden");

                        window.setTimeout(() => {
                            self.noticeContainer.classList.add("is-hidden");
                        }, 10000);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    showNotices() {
        const self = this;
        if (self.noticeContainer) {
            self.noticeContainer.classList.remove("is-hidden");

            // window.setTimeout(() => {
            //     self.noticeContainer.classList.add("is-hidden");
            // }, 10000);
        }
    }
}
